import React from 'react';

const CategoriesPlaceholder = () => {
  return (
    <div className="placeholder-cat">
      <div className="placeholder-cat-i animation" />
      <div className="placeholder-cat-i animation" />
      <div className="placeholder-cat-i animation" />
      <div className="placeholder-cat-i animation" />
      <div className="placeholder-cat-i animation" />
    </div>
  );
};

export default CategoriesPlaceholder;
